import { RoleMenuService } from "@/common/api.service";
import {
  GET_ROLE_LIST,
  POST_ROLE,
  UPDATE_ROLE,
  GET_ROLE_WISE_MENU_LIST,
  CREATE_ROLE_WISE_MENU,
  GET_MENU_LIST,
  GET_ROLE_WISE_PERMISSION_LIST,
  GET_ALL_PERMISSION,
  UPDATE_PERMISSION
} from "./actions.type";
import { SET_ERROR, ISLOADING } from "./mutations.type";

const state = {
  errors: null,
  role_menu_list: {},
};

const getters = {
  role_menu_list(state) {
    return state.role_menu_list;
  },
};

const actions = {
  async [GET_ROLE_LIST](context) {
    RoleMenuService.init();
    RoleMenuService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      RoleMenuService.get(`auth/access/roles`)
        .then((data) => {
          context.commit(ISLOADING, false);
          context.commit("setRoleList", data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          context.commit(SET_ERROR, response);
          resolve(response);
        });
    });
  },

  // Store Role
  async [UPDATE_ROLE](context, payload) {
    RoleMenuService.init();
    RoleMenuService.setHeader();
    return new Promise((resolve) => {
      RoleMenuService.put(`auth/access/role-update/${payload.id}`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Store Role
  async [POST_ROLE](context, payload) {
    RoleMenuService.init();
    RoleMenuService.setHeader();
    return new Promise((resolve) => {
      RoleMenuService.post(`auth/access/role`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Get Role wise Menu list
  async [GET_ROLE_WISE_MENU_LIST](context, payload) {
    RoleMenuService.init();
    RoleMenuService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      RoleMenuService.get(`auth/role-wise-menus/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          context.commit(SET_ERROR, response);
          resolve(response);
        });
    });
  },

  // Store Role Wise Menu
  async [CREATE_ROLE_WISE_MENU](context, payload) {
    RoleMenuService.init();
    RoleMenuService.setHeader();
    return new Promise((resolve) => {
      RoleMenuService.post(`auth/store-role-wise-menus`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Get user wise Menu List
  async [GET_MENU_LIST](context) {
    RoleMenuService.init();
    RoleMenuService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      RoleMenuService.get(`auth/menus`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          context.commit(SET_ERROR, response);
          resolve(response);
        });
    });
  },

  // Get Role wise Permission list
  async [GET_ROLE_WISE_PERMISSION_LIST](context, payload) {
    RoleMenuService.init();
    RoleMenuService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      RoleMenuService.get(`permission/view/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          context.commit(SET_ERROR, response);
          resolve(response);
        });
    });
  },

  // Get All Permission
  async [GET_ALL_PERMISSION](context) {
    RoleMenuService.init();
    RoleMenuService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      RoleMenuService.get(`permission/all`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          context.commit(SET_ERROR, response);
          resolve(response);
        });
    });
  },

  // Update Permission
  async [UPDATE_PERMISSION](context, payload) {
    RoleMenuService.init();
    RoleMenuService.setHeader();
    return new Promise((resolve) => {
      RoleMenuService.post(`permission/update`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [ISLOADING](state, loading) {
    state.isLoading = loading;
  },
  setRoleMenuList(state, data) {
    state.role_menu_list = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
